import React, { useLayoutEffect, useRef } from 'react';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_dark from "@amcharts/amcharts4/themes/dark";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_dark);
am4core.useTheme(am4themes_animated);

export interface IAngularGaugeChartProps {
    id: string;
    value: number;
    minValue: number;
    maxValue: number;
  }

const AngularGaugeChart: React.FC<IAngularGaugeChartProps> = (props: IAngularGaugeChartProps) => {
    useLayoutEffect(() => {    
        let chart = am4core.create(`${props.id}`, am4charts.GaugeChart);
        chart.hiddenState.properties.opacity = 0; // this makes initial fade in effect

        chart.innerRadius = -25;

        let range = props.maxValue - props.minValue;

        let axis = chart.xAxes.push(new am4charts.ValueAxis() as any);
        axis.min = props.minValue;
        axis.max = props.maxValue;
        axis.strictMinMax = true;
        axis.renderer.grid.template.stroke = new am4core.InterfaceColorSet().getFor("background");
        axis.renderer.grid.template.strokeOpacity = 0.3;

        let colorSet = new am4core.ColorSet();

        let range0 = axis.axisRanges.create();
        range0.value = props.minValue;
        range0.endValue = props.minValue + range * .3333333;
        range0.axisFill.fillOpacity = 1;
        range0.axisFill.fill = colorSet.getIndex(0);
        range0.axisFill.zIndex = - 1;

        let range1 = axis.axisRanges.create();
        range1.value = props.minValue + range * .3333333;
        range1.endValue = props.minValue + range * .6666666;
        range1.axisFill.fillOpacity = 1;
        range1.axisFill.fill = colorSet.getIndex(2);
        range1.axisFill.zIndex = -1;

        let range2 = axis.axisRanges.create();
        range2.value = props.minValue + range * .6666666;
        range2.endValue = props.maxValue;
        range2.axisFill.fillOpacity = 1;
        range2.axisFill.fill = colorSet.getIndex(4);
        range2.axisFill.zIndex = -1;

        let hand = chart.hands.push(new am4charts.ClockHand());
        hand.showValue(props.value);
    
        return () => {
          chart.dispose();
        };
      }, [props]);
    
    return (
        <div className="AngularGaugeChart" id={props.id} style={{ width: "100%", height: "500px" }}></div>
    );
  }
  
  export default AngularGaugeChart;